import { render, staticRenderFns } from "./exercises.vue?vue&type=template&id=c078cbee&scoped=true&"
import script from "./exercises.vue?vue&type=script&lang=js&"
export * from "./exercises.vue?vue&type=script&lang=js&"
import style0 from "./exercises.vue?vue&type=style&index=0&id=c078cbee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c078cbee",
  null
  
)

export default component.exports